import * as t from 'ts-schema';
import { COMMENT, DEEP_COMMENT, REPLY } from '../CommentTypes';
const metaDescriptionSchema = t.object({
  translationKey: t.string,
  locationPath: t.optional(t.string),
  options: t.object({
    transcriptUtteranceId: t.optional(t.string)
  })
});
export const CommentDetailSchema = t.object({
  archived: t.boolean,
  archivedAt: t.optional(t.string),
  atMentionedUserIds: t.array(t.number),
  createdAt: t.string,
  id: t.string,
  message: t.string,
  metaDescription: t.optional(metaDescriptionSchema),
  objectId: t.string,
  objectType: t.string,
  parentId: t.optional(t.string),
  read: t.boolean,
  resolved: t.optional(t.boolean),
  type: t.union(t.literal(COMMENT), t.literal(DEEP_COMMENT), t.literal(REPLY)),
  updatedAt: t.string,
  userId: t.number
});
export const FetchCommentsResponseSchema = t.object({
  results: t.array(CommentDetailSchema),
  total: t.number,
  paging: t.optional(t.object({
    next: t.object({
      after: t.string
    })
  }))
});